import INITIAL_VALUES from '@app/constants/editingDocumentsFilterInitialValues';
import {
  EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE,
  EDITING_DOCUMENTS_LIST_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { EditingDocumentsAction } from '@app/store/editingDocuments/actions';

type EditingDocumentsLimitState = number;

const initialState: EditingDocumentsLimitState = INITIAL_VALUES.limit;

export default function reducer(
  state: EditingDocumentsLimitState = initialState,
  action: EditingDocumentsAction
) {
  switch (action.type) {
    case EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE:
      return initialState;
    case EDITING_DOCUMENTS_LIST_FETCH_SUCCESS:
      return action.payload.limit;
    default:
      return state;
  }
}
